import { Spin } from "antd";
import { useEffect, useState } from "react";
import EditButton from "../../../components/buttons/edit";
import MotoristaForm from "../../../components/motoristas/form";
import {
    InlineContainer,
    TitleHeader,
    VerticalContainer,
} from "../../../components/styled";
import ViewContainer from "../../../components/view_container";
import { getMorotista, getMotorista, updateMotorista } from "../../../services/motoristas";
import { getVeiculo, updateVeiculo } from "../../../services/veiculos";
import VeiculosForm from "../../../components/veiculos/form";

export default function EditVeiculo({ computedMatch }) {
  const [error, setError] = useState();
  const [veiculo, setVeiculo] = useState();
  const [loading, setLoading] = useState(false);
  const [viewMode, setViewMode] = useState(true);
  const { params } = computedMatch;
  const onFinish = async (values) => {
    try {
      setLoading(true);
      await updateVeiculo(veiculo, values);
    } catch (err) {
      console.log(err);
      setError(err.error);
    } finally {
      setLoading(false);
    }
  };

  const handleVeiculo = async () => {
    const data = await getVeiculo(params.id);
    setVeiculo(data);
  };

  useEffect(() => {
    handleVeiculo();
  }, []);

  return (
    <>
      {veiculo ? (
        <VerticalContainer>
          <InlineContainer>
            <TitleHeader></TitleHeader>
            <EditButton viewMode={viewMode} setViewMode={setViewMode} />
          </InlineContainer>

          <ViewContainer item={veiculo}>
            <VeiculosForm
              initialValues={{ ...veiculo }}
              onFinish={onFinish}
              error={error}
              setError={setError}
              loading={loading}
              viewMode={viewMode}
            />
          </ViewContainer>
        </VerticalContainer>
      ) : (
        <Spin />
      )}
    </>
  );
}
